import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";
import axios from "axios";
import CatalogoResponExpendio from "../../catalogos/catalogoRspnExp";

export const GestionarProcedimiento = (props) => {
  /*  variables de estados */

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const fechavehiculo = useRef();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const txtIdvehiculo = useRef();
  const txtRitm = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtObserStatus = useRef();
  const txtStatus = useRef();
  const txtDireccionRespon = useRef();
  const txtPeso = useRef();
  const txtMonto = useRef();
  const txtCedulaPro = useRef();
  const txtNombrePro = useRef();
  const txtNumPro = useRef();
  const txtDireccionPro = useRef();
  const txtValorVh = useRef();
  const txtId = useRef();
  const txtCheck = useRef();
  const txtCapCarga = useRef();
  const txtFechaIns = useRef();
  const [anio, setAnio] = useState([]);
  const [montoAnual, setMontoAnual] = useState(0.0);
  const [values, setValues] = useState({
    apellidos: "",
    cedula: "",
    ciudad: "",
    correoe: "",
    credito: "",
    declara: 0,
    direccion: "",
    direccionage: "",
    direccionresp: "",
    email: "",
    exonintereses: false,
    exonintereses1x500: false,
    exoninteresesmina: false,
    exoninteresesproduccion: false,
    exonmultas: false,
    exonmultas1x500: false,
    exonmultasmina: false,
    exonmultasproduccion: false,
    exonrecargos: false,
    exonrecargos1x500: false,
    exonrecargosmina: false,
    exonrecargosproduccion: false,
    fechainscripcion: "",
    fechainscripcion1x1000: null,
    fechainscripcionmina: null,
    fechainscripcionproduccion: null,
    fnacimiento: "",
    idagente: "",
    idtipoagente: "",
    impuesto1x1000: false,
    mina: false,
    municipio: "",
    nacionalidad: "",
    nombre: "",
    nombres: "",
    nrolicencia: "",
    nrolicencia1x1000: null,
    nrolicenciamina: null,
    nrolicenciaproduccion: null,
    nroresolucion: "",
    nroresolucion1x1000: null,
    nroresolucionmina: null,
    nroresolucionproduccion: null,
    observacionstatus: "",
    observacionstatus1x1000: null,
    observacionstatusmina: null,
    observacionstatusproduccion: null,
    produccion: false,
    reprelegal: "",
    rif: "",
    sexo: "",
    status: "",
    status1x1000: null,
    statusmina: null,
    statusproduccion: null,
    telefono: "",
    tlf1: "",
    tlf2: "",
  });

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const cmbSex = useRef();
  const [catalogo, setCatalogo] = useState(false);
  const txtApeRespon = useRef();
  const txtEmail1 = useRef();
  const txtEmail2 = useRef();
  const txtFechNac = useRef();
  const txtCelRespon = useRef();
  const cmbNacionalidad = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const [tecla, setTecla] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const txtResolucion = useRef();
  const txtLicencia = useRef();
  const [interes, setInteres] = useState(false);
  const [multas, setMultas] = useState(false);
  const [recargos, setRecargos] = useState(false);
  const [observacion, setObservacion] = useState("hidden");
  const chkIn = useRef();
  const chkIn1 = useRef();
  const chkIn2 = useRef();
  const [fechaTope, setFechaTope] = useState();
  const txtCiudad = useRef();
  const txtMunicipio = useRef();
  const [municipios, setMunicipios] = useState();
  const [ciudades, setCiudades] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState(null);
  const styleInput = {
    backgroundColor: "#ffff",
    color: "#444242",
  };

  const styleInputDirec = {
    backgroundColor: "#ffff",
    color: "#444242",
    height: 50,
  };

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const onChange = (event) => {
    if (
      event.target.name === "inputPropiet" ||
      event.target.name === "inputDirecpropiet" ||
      event.target.name === "inputRifCed" ||
      event.target.name === "nombrerespo" ||
      event.target.name === "aperespo" ||
      event.target.name === "propiEmail" ||
      event.target.name === "licencia" ||
      event.target.name === "resolucion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    } else if (event.target.name === "flexCheckChecked0") {
      if (!interes) {
        setInteres(true);
      } else {
        setInteres(false);
      }
    } else if (event.target.name === "flexCheckChecked1") {
      if (!multas) {
        setMultas(true);
      } else {
        setMultas(false);
      }
    } else if (event.target.name === "flexCheckChecked2") {
      if (!recargos) {
        setRecargos(true);
      } else {
        setRecargos(false);
      }
    } else if (event.target.name === "status") {
      if (event.target.value === "52") {
        if (observacion === "hidden") {
          setObservacion("visible");
        } else {
          setObservacion("hidden");
        }
      } else {
        setObservacion("hidden");
        txtObserStatus.current.value = "";
      }
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (operacion === 1 || operacion === 2) {
      if (txtFechaIns.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la fecha de inscripción",
          icono: "informacion",
        });
        txtFechaIns.current.focus();
        sigue = false;
      } else if (txtStatus.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un estatus",
          icono: "informacion",
        });
        txtStatus.current.focus();
        sigue = false;
      } else if (txtCedulaPro.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el RIF del expendio",
          icono: "informacion",
        });
        txtCedulaPro.current.focus();
        sigue = false;
      } else if (txtNombrePro.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el nombre del expendio",
          icono: "informacion",
        });
        txtNombrePro.current.focus();
        sigue = false;
      } else if (txtDireccionPro.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la direccion del expendio",
          icono: "informacion",
        });
        txtDireccionPro.current.focus();
        sigue = false;
      } else if (txtNumPro.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el contacto del expendio",
          icono: "informacion",
        });
        txtNumPro.current.focus();
        sigue = false;
      } else if (!validaNumeroTelefono(txtNumPro.current.value.trim())) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un contacto valido del expendio",
          icono: "informacion",
        });
        txtNumPro.current.value = "";
        txtNumPro.current.focus();
        sigue = false;
      } else if (txtEmail1.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el correo del expendio",
          icono: "informacion",
        });
        txtEmail1.current.focus();
        sigue = false;
      } else if (!validaEmail(txtEmail1.current.value.trim())) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un correo valido al expendio",
          icono: "informacion",
        });
        txtEmail1.current.value = "";
        txtEmail1.current.focus();
        sigue = false;
      } else if (txtCiudad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar una Ciudad",
          icono: "informacion",
        });
        txtCiudad.current.focus();
        sigue = false;
      } else if (txtCedula.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la cedula de la persona",
          icono: "informacion",
        });
        txtCedula.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar una nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSex.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar un Sexo",
            icono: "informacion",
          });
          cmbSex.current.focus();
          sigue = false;
        } else if (txtNombreRespon.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNombreRespon.current.focus();
          sigue = false;
        } else if (txtApeRespon.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeRespon.current.focus();
          sigue = false;
        } else if (txtDireccionPro.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la direccion del responsable",
            icono: "informacion",
          });
          txtDireccionPro.current.focus();
          sigue = false;
        } else if (txtEmail2.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el correo del responsable",
            icono: "informacion",
          });
          txtEmail2.current.focus();
          sigue = false;
        } else if (txtFechNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la fecha de nacimiento del responsable",
            icono: "informacion",
          });
          txtFechNac.current.focus();
          sigue = false;
        } else if (!validaEmail(txtEmail2.current.value.trim())) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar un correo valido a responsable",
            icono: "informacion",
          });
          txtEmail2.current.value = "";
          txtEmail2.current.focus();
          sigue = false;
        } else if (!validaNumeroTelefono(txtTlf1.current.value.trim())) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar un contacto del representante",
            icono: "informacion",
          });
          txtTlf1.current.value = "";
          txtTlf1.current.focus();
          sigue = false;
        } else if (!validaNumeroTelefono(txtTlf2.current.value.trim())) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar un contacto del representante",
            icono: "informacion",
          });
          txtTlf2.current.value = "";
          txtTlf2.current.focus();
          sigue = false;
        }
      } else if (txtLicencia.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el N° de licencia",
          icono: "informacion",
        });
        txtLicencia.current.focus();
        sigue = false;
      } else if (txtResolucion.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el N° de Resolucion",
          icono: "informacion",
        });
        txtResolucion.current.focus();
        sigue = false;
      } else if (txtMonto.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar el Credito",
          icono: "informacion",
        });
        txtMonto.current.focus();
        sigue = false;
      }
    }
    if (sigue) {
      var agente = [];
      var repre = [];

      agente.push({
        idagente: txtId.current.value === "" ? 0 : txtId.current.value,
        nombre: txtNombrePro.current.value.trim(),
        direccion: txtDireccionPro.current.value.trim(),
        rif: txtCedulaPro.current.value,
        nrolicencia: txtLicencia.current.value.trim(),
        nroresolucion: txtResolucion.current.value.trim(),
        reprelegal: txtCedula.current.value.trim(),
        telefono: txtNumPro.current.value.trim(),
        fechainscripcion: txtFechaIns.current.value.trim(),
        status: txtStatus.current.value.trim(),
        idtipoagente: 2,
        observacionstatus: txtObserStatus.current.value.trim(),
        credito: parseFloat(
          txtMonto.current.value.replace(/\./g, "").replace(",", ".")
        ),
        email: txtEmail1.current.value,
        exonintereses: interes,
        exonmultas: multas,
        exonrecargos: recargos,
        municipio: txtMunicipio.current.value.trim(),
        ciudad: txtCiudad.current.value,
      });
      repre.push({
        cedula: parseInt(txtCedula.current.value),
        correoe: txtEmail2.current.value,
        tlf1: txtTlf1.current.value,
        tlf2: txtTlf2.current.value,
        apellidos: txtApeRespon.current.value,
        direccion: txtDireccionRespon.current.value,
        fnacimiento: txtFechNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value,
        sexo: cmbSex.current.value,
      });

      setBody({
        operacionper: operacionPer,
        agente: agente,
        repre: repre,
      });

      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/agente/actualizaragente/${parseInt(
      operacion
    )}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar1(false);
    setActivate(false);
    txtId.current.value = "";
    txtCedula.current.value = "";
    txtNombreRespon.current.value = "";
    txtApeRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmail1.current.value = "";
    txtEmail2.current.value = "";
    txtFechNac.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    cmbNacionalidad.current.value = "";
    cmbSex.current.value = "";
    chkIn.current.checked = false;
    chkIn2.current.checked = false;
    chkIn1.current.checked = false;
    setValues({
      apellidos: "",
      cedula: "",
      ciudad: "",
      correoe: "",
      credito: "",
      declara: 0,
      direccion: "",
      direccionage: "",
      direccionresp: "",
      email: "",
      exonintereses: false,
      exonintereses1x500: false,
      exoninteresesmina: false,
      exoninteresesproduccion: false,
      exonmultas: false,
      exonmultas1x500: false,
      exonmultasmina: false,
      exonmultasproduccion: false,
      exonrecargos: false,
      exonrecargos1x500: false,
      exonrecargosmina: false,
      exonrecargosproduccion: false,
      fechainscripcion: "",
      fechainscripcion1x1000: null,
      fechainscripcionmina: null,
      fechainscripcionproduccion: null,
      fnacimiento: "",
      idagente: "",
      idtipoagente: "",
      impuesto1x1000: false,
      mina: false,
      municipio: "",
      nacionalidad: "",
      nombre: "",
      nombres: "",
      nrolicencia: "",
      nrolicencia1x1000: null,
      nrolicenciamina: null,
      nrolicenciaproduccion: null,
      nroresolucion: "",
      nroresolucion1x1000: null,
      nroresolucionmina: null,
      nroresolucionproduccion: null,
      observacionstatus: "",
      observacionstatus1x1000: null,
      observacionstatusmina: null,
      observacionstatusproduccion: null,
      produccion: false,
      reprelegal: "",
      rif: "",
      sexo: "",
      status: "",
      status1x1000: null,
      statusmina: null,
      statusproduccion: null,
      telefono: "",
      tlf1: "",
      tlf2: "",
    });
    setOperacion(0);
    setMsg("");
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg === "Registro Creado Correctamente." ||
      msg === "Registro Modificado Correctamente." ||
      msg === "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setObservacion("hidden");
    blanquear();
    props.onHideCancela();
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const handleAceptaCatalogoPer = (
    ced,
    corr,
    tlf1,
    tlf2,
    ape,
    direc,
    fcn,
    nac,
    nom,
    sex
  ) => {
    setCatalogo(false);
    setHabilitadoNU(false);

    txtCedula.current.value = ced;
    txtNombreRespon.current.value = nom !== null ? nom.trim() : "";
    txtApeRespon.current.value = ape !== null ? ape.trim() : "";
    txtDireccionRespon.current.value = direc !== null ? direc : "";
    txtEmail2.current.value = corr !== null ? corr.trim() : "";
    txtFechNac.current.value =
      fcn !== null ? moment(fcn).format("YYYY-MM-DD") : "";
    txtTlf1.current.value = tlf1 !== null ? tlf1.trim() : "";
    txtTlf2.current.value = tlf2 !== null ? tlf2.trim() : "";
    cmbNacionalidad.current.value = nac !== null ? nac.toString().trim() : "";
    cmbSex.current.value = sex !== null ? sex.toString().trim() : "";
  };

  /* valdar buscador por numero */
  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        //setActivate(true);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApeRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmail2.current.value = "";
          txtFechNac.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";
          cmbNacionalidad.current.value = "";
          cmbSex.current.value = "";
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApeRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmail2.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            txtFechNac.current.value = moment(response.data.fnacimiento).format(
              "YYYY-MM-DD"
            );
            cmbNacionalidad.current.value =
              response.data.nacionalidad.toString();
            cmbSex.current.value = response.data.sexo.toString();

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let id = "18";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => (e) => {
    e.preventDefault();
    if (id !== "") {
      let campos = "*";
      let nomtab = "ciudad";
      let nomid = "idmunicipio";

      let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setCiudades(response.data);
          }
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        });
    } else [setCiudades("")];
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  useEffect(() => {
    let anio =
      parseInt(
        moment(JSON.parse(localStorage.getItem("fechasistema")))
          .format("YYYY-MM-DD")
          .substring(0, 4)
      ) - 18;
    let fecha = anio + "-12-31";

    setFechaTope(fecha);
  }, []);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        selectMunicipio();
        setHabilitadoNU(false);
        if (props.expendedor.status !== "52") {
          setObservacion("hidden");
        } else {
          setObservacion("visible");
        }
        setOperacionPer(0);
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setCiudades(props.ciudades);
          setValues(props.expendedor);
        } else {
          setObservacion("hidden");
          txtCedula.current.value = "";
          txtNombreRespon.current.value = "";
          txtApeRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmail1.current.value = "";
          txtEmail2.current.value = "";
          txtFechNac.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";
          cmbNacionalidad.current.value = "";
          cmbSex.current.value = "";
          chkIn.current.checked = false;
          chkIn2.current.checked = false;
          chkIn1.current.checked = false;
          txtFechaIns.current.value = moment(
            JSON.parse(localStorage.getItem("fechasistema"))
          ).format("YYYY-MM-DD");
          setCiudades("");
          setValues({
            apellidos: "",
            cedula: "",
            ciudad: "",
            correoe: "",
            credito: "",
            declara: 0,
            direccion: "",
            direccionage: "",
            direccionresp: "",
            email: "",
            exonintereses: false,
            exonintereses1x500: false,
            exoninteresesmina: false,
            exoninteresesproduccion: false,
            exonmultas: false,
            exonmultas1x500: false,
            exonmultasmina: false,
            exonmultasproduccion: false,
            exonrecargos: false,
            exonrecargos1x500: false,
            exonrecargosmina: false,
            exonrecargosproduccion: false,
            fechainscripcion: "",
            fechainscripcion1x1000: null,
            fechainscripcionmina: null,
            fechainscripcionproduccion: null,
            fnacimiento: "",
            idagente: "",
            idtipoagente: "",
            impuesto1x1000: false,
            mina: false,
            municipio: "",
            nacionalidad: "",
            nombre: "",
            nombres: "",
            nrolicencia: "",
            nrolicencia1x1000: null,
            nrolicenciamina: null,
            nrolicenciaproduccion: null,
            nroresolucion: "",
            nroresolucion1x1000: null,
            nroresolucionmina: null,
            nroresolucionproduccion: null,
            observacionstatus: "",
            observacionstatus1x1000: null,
            observacionstatusmina: null,
            observacionstatusproduccion: null,
            produccion: false,
            reprelegal: "",
            rif: "",
            sexo: "",
            status: "",
            status1x1000: null,
            statusmina: null,
            statusproduccion: null,
            telefono: "",
            tlf1: "",
            tlf2: "",
          });
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Fiscal."
            : props.operacion === 2
            ? "Editar Fiscal."
            : props.operacion === 3
            ? "Eliminar Fiscal."
            : "Consultar Fiscal."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <CatalogoResponExpendio
          show={catalogo}
          onHideCancelaCatPer={handleCatalogo}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded mx-auto">
              <div className=" py-3 row d-flex justify-content-between col-md-12 py-2 ">
                <div
                  className="input-group py-1 input-group-sm col-md-2"
                  style={{ height: 27 }}
                >
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={true}
                    ref={txtId}
                    value={props.expendedor ? props.expendedor.idagente : ""}
                    style={styleInput}
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Fecha de Inscripción:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    ref={txtFechaIns}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={
                      operacion === 4 || operacion === 3 || operacion === 1
                        ? true
                        : deshabilitado
                    }
                    name="fechainscripcion"
                    defaultValue={
                      props.expendedor
                        ? moment(props.expendedor.fechainscripcion).format(
                            "YYYY-MM-DD"
                          )
                        : ""
                    }
                    onChange={onChange}
                    id="inputFechaInscripcion"
                    style={styleInput}
                  />
                </div>

                <div
                  className="input-group py-1 input-group-sm col-md-2"
                  style={{ height: 27 }}
                >
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Estatus:
                  </label>
                  <select
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtStatus}
                    className="form-control col-md-6"
                    id="inputStatus"
                    name="status"
                    value={values.status}
                    onChange={onChange}
                    style={styleInput}
                  >
                    <option value="">Seleccione</option>
                    <option value="51">ACTIVO</option>
                    <option value="52">INACTIVO</option>
                  </select>
                </div>

                <div
                  className="input-group py-1 input-group-sm col-sm-5"
                  style={{ visibility: observacion, height: 27 }}
                >
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Observación:
                  </label>
                  <textarea
                    style={styleInput}
                    className="form-control uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtObserStatus}
                    name="direccionpropie"
                    defaultValue={
                      props.expendedor ? props.expendedor.observacionstatus : ""
                    }
                    onChange={onChange}
                    id="inputDirecpropiet"
                  />
                </div>
              </div>
              <div className="container rounded row d-flex border justify-content-between mx-auto col-md-12">
                <div className=" col-md-6 row py-3 px-4 justify-content-between ">
                  <div className="col-sm-11 p-0 text-success2">
                    <h4 className="text-success2">
                      <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                      Fiscal
                    </h4>
                    <hr />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula o RIF:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCedulaPro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="15"
                      defaultValue={
                        props.expendedor ? props.expendedor.rif : ""
                      }
                      onChange={onChange}
                      id="inputRifCed"
                      name="inputRifCed"
                      style={styleInput}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre/Razón Social:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtNombrePro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        props.expendedor ? props.expendedor.nombre : ""
                      }
                      onChange={onChange}
                      id="inputPropiet"
                      name="inputPropiet"
                      style={styleInput}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtDireccionPro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        props.expendedor ? props.expendedor.direccionage : ""
                      }
                      onChange={onChange}
                      id="inputDirecpropiet"
                      name="inputDirecpropiet"
                      style={styleInputDirec}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Teléfono:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      maxLength="12"
                      ref={txtNumPro}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      defaultValue={
                        props.expendedor ? props.expendedor.telefono : ""
                      }
                      onChange={onChange}
                      id="inputTelefonopropie"
                      name="numTlf"
                      style={styleInput}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-7">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      onChange={onChange}
                      className="form-control uppercase"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      aria-label="Sizing example input"
                      ref={txtEmail1}
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.expendedor ? props.expendedor.email : ""
                      }
                      id="inputEmail"
                      name="email1"
                      style={styleInput}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Municipio:
                    </label>

                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtMunicipio}
                      className="form-control form-control-sm"
                      id="inputStatus"
                      name="municipio"
                      onChange={onChange}
                      value={values.municipio}
                      style={styleInput}
                    >
                      <option value="" onClick={selectCiudad("")}>
                        Seleccione
                      </option>
                      {municipios &&
                        municipios.map((item, index) => (
                          <option
                            key={index}
                            value={item.idmunicipio}
                            onClick={selectCiudad(item.idmunicipio)}
                          >
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Ciudad:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCiudad}
                      className="form-control form-control-sm"
                      id="inputStatus"
                      name="ciudad"
                      onChange={onChange}
                      value={values.ciudad}
                      style={styleInput}
                    >
                      <option value="">Seleccione</option>
                      {ciudades &&
                        ciudades.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className=" col-md-6 row py-3 px-4 justify-content-between ">
                  <div className="col-sm-11 p-0 text-success2">
                    <h4 className="text-success2">
                      <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                      Responsable
                    </h4>
                    <hr />
                  </div>

                  <div className="input-group mx-auto py-1 row input-group-sm col-sm-6">
                    <label
                      className="col-sm-3 input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula:
                    </label>
                    <select
                      disabled={!habilitadoNU}
                      ref={cmbNacionalidad}
                      value={props.expendedor && props.expendedor.nacionalidad}
                      className="col-sm-2 form-control form-control-sm"
                      style={styleInput}
                    >
                      <option value="">-</option>
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="E">
                        E
                      </option>
                    </select>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength={14}
                      className="col-sm-5 form-control form-control-sm"
                      defaultValue={
                        props.expendedor ? props.expendedor.cedula : ""
                      }
                      placeholder="123456789"
                      ref={txtCedula}
                      name="cedularespo"
                      onChange={onChange}
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      id="inputCedrespon"
                      style={styleInput}
                    />
                    <button
                      className="btn btn-sm col-sm-2  btn-info "
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={handleCatalogo}
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>

                  <div className="col-sm-3"></div>

                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sexo:
                    </label>
                    <select
                      disabled={!habilitadoNU}
                      value={props.expendedor && props.expendedor.sexo}
                      ref={cmbSex}
                      className=" form-control form-control-sm"
                      id="inputLetraRif"
                      style={styleInput}
                    >
                      <option value="">-</option>
                      <option key="0" value="M">
                        M
                      </option>
                      <option key="1" value="F">
                        F
                      </option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombres:
                    </label>
                    <input
                      type="text"
                      className="form-control uppercase"
                      defaultValue={
                        props.expendedor ? props.expendedor.nombres : ""
                      }
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtNombreRespon}
                      disabled={!habilitadoNU}
                      name="nombrerespo"
                      onChange={onChange}
                      id="inputNombrerespon"
                      style={styleInput}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Apellidos:
                    </label>
                    <input
                      type="text"
                      className="form-control uppercase"
                      disabled={!habilitadoNU}
                      defaultValue={
                        props.expendedor ? props.expendedor.apellidos : ""
                      }
                      aria-label="Sizing example input"
                      ref={txtApeRespon}
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputApellidos"
                      name="aperespo"
                      style={styleInput}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <textarea
                      type="text"
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      defaultValue={
                        props.expendedor ? props.expendedor.direccionresp : ""
                      }
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtDireccionRespon}
                      disabled={!habilitadoNU}
                      name="direccionrespo"
                      onChange={onChange}
                      style={styleInputDirec}
                      id="inputDireccionrespon"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      className="form-control uppercase"
                      disabled={!habilitadoNU}
                      aria-label="Sizing example input"
                      ref={txtEmail2}
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.expendedor ? props.expendedor.correoe : ""
                      }
                      id="inputEmail2"
                      name="email2"
                      onChange={onChange}
                      style={styleInput}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha Nacimiento:
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      disabled={!habilitadoNU}
                      ref={txtFechNac}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.expendedor
                          ? moment(props.expendedor.fnacimiento).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      max={fechaTope}
                      id="inputFnac"
                      style={styleInput}
                    />
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Teléfono:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      ref={txtTlf1}
                      aria-describedby="inputGroup-sizing-sm"
                      maxLength="12"
                      disabled={!habilitadoNU}
                      defaultValue={
                        props.expendedor ? props.expendedor.tlf1 : ""
                      }
                      onChange={onChange}
                      id="inputTelefrespon"
                      name="numTlf2"
                      style={styleInput}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled={!habilitadoNU}
                      aria-label="Sizing example input"
                      ref={txtTlf2}
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.expendedor ? props.expendedor.tlf2 : ""
                      }
                      id="inputCel"
                      onChange={onChange}
                      name="numTlf3"
                      style={styleInput}
                    />
                  </div>
                </div>

                <hr className="col-sm-11 py-0 px-2 mx-auto container text-success2" />

                <div className="col-sm-12 row p-1">
                  <div className="container py-2 col-md-3 row align-items-start">
                    <h4 className="text-success2">
                      <i className="fas fa-lg px-2 fa-user-edit"></i> Datos
                      Tributarios{" "}
                    </h4>
                    <div className="input-group input-group-sm col-sm-12 ">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Resolución:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtResolucion}
                        defaultValue={
                          props.expendedor ? props.expendedor.nroresolucion : ""
                        }
                        onChange={onChange}
                        name="resolucion"
                        style={styleInput}
                      />
                    </div>
                  </div>

                  <div className="col-sm-3 py-2 row align-items-end">
                    <div className="input-group input-group-sm col-sm-12 ">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Licencia:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtLicencia}
                        defaultValue={
                          props.expendedor ? props.expendedor.nrolicencia : ""
                        }
                        onChange={onChange}
                        id="inputRitm"
                        name="licencia"
                        style={styleInput}
                      />
                    </div>
                  </div>

                  <div className="col-sm-3 row  align-items-end">
                    <div className="input-group input-group-sm py-2 col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Crédito Bs:
                      </label>
                      <input
                        type="text"
                        className="form-control text-right"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        maxLength="10"
                        ref={txtMonto}
                        defaultValue={
                          props.credito
                            ? formatMoneda(
                                props.credito
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : ""
                        }
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                        name="montoanual"
                        style={styleInput}
                      />
                    </div>
                  </div>

                  <fieldset className=" row col-sm-3 mx-auto border rounded">
                    <legend
                      className="float-none w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Exonerar
                    </legend>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked0"
                        name="flexCheckChecked0"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn}
                        onChange={onChange}
                        defaultChecked={props.expendedor.exonintereses}
                      />
                      <label
                        className="form-check-label "
                        htmlFor="flexCheckChecked0"
                      >
                        Interés
                      </label>
                    </div>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked1"
                        name="flexCheckChecked1"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn1}
                        onChange={onChange}
                        defaultChecked={props.expendedor.exonmultas}
                      />
                      <label
                        className="form-check-label "
                        htmlFor="flexCheckChecked1"
                      >
                        Multas
                      </label>
                    </div>

                    <div className="form-check col form-check-inline">
                      <input
                        className="form-check-input rounded rounded-circle"
                        type="checkbox"
                        id="flexCheckChecked2"
                        name="flexCheckChecked2"
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={chkIn2}
                        onChange={onChange}
                        defaultChecked={props.expendedor.exonrecargos}
                      />
                      <label
                        className="form-check-label "
                        htmlFor="flexCheckChecked2"
                      >
                        Recargos
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer /* style={{ backgroundColor: "rgb()" }} */>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/fiscales/modalProcedimiento.js